import React, { Component } from "react";
import { connect } from "react-redux";
import PasswordEye from "./PasswordEye";
import Datetime from "react-datetime";
import ReactSlider from "react-slider";
import InputMask from "react-input-mask";
import ValidationErrors from "../../Settings/ValidationErrors";
import moment from "moment";
import ToggleSwitch from "../ToggleSwitch";

class OmniFormGroup extends Component {
  state = {
    touched: false,
    errors: null,
  };

  validateDateInput = (e) => {
    const isValid = moment.isMoment(e) || e === "";
    const touched = true;

    const errors = !isValid ? "Incorrect Date Format" : null;

    this.setState({ touched, errors });
    if (this.props.onClose instanceof Function) {
      this.props.onClose();
    }
  };

  onChangeAlpha = (e) => {
    const { onChange } = this.props;
    const { validationMessage } = e.target;

    const touched = true;

    const errors = !!validationMessage
      ? "incorrect format (only a-z allowed)"
      : null;

    this.setState({ touched, errors });

    onChange(e);
  };

  renderDateTimeInput = (props, openCalendar) => {
    props.className += " " + this.props.className;

    const maskPlaceholder = null;

    return (
      <div
        className={this.props.Disabled ? "date-picker-disabled" : "date-picker"}
      >
        <InputMask
          key="date"
          mask="99/99/9999"
          {...props}
          maskplaceholder={maskPlaceholder}
        />
        {!this.props.Disabled && (
          <i className="icon-omni-date-picker" onClick={openCalendar} />
        )}
      </div>
    );
  };
  render() {
    const { _, ...rest } = this.props;
    const labelText = this.props.LabelName
      ? this.props.LabelName
      : this.props.Name;

    return (
      <div
        className={
          "form-group omni-form-group omni-form-group-" + this.props.Id
        }
      >
        <>
          <label className="metadata-label">
            {labelText}
            {this.props.Disabled && !this.props.disabledBuTNoLockIcon ? (
              <span
                title={labelText + " " + _.MetadataKeyLockedForEditing}
                className="icon-omni-lock"
              />
            ) : (
              ""
            )}
          </label>
        </>
        {(() => {
          const { touched, errors: message } = this.state;

          switch (this.props.Type) {
            case "text":
            case "file":
            case "email":
            case "password":
            case "number":
              return (
                <input
                  type={this.props.Type}
                  className={
                    "form-control" +
                    (this.props.className != null
                      ? " " + this.props.className
                      : "")
                  }
                  id={this.props.Id}
                  name={this.props.Id}
                  aria-describedby={this.props.Id + "Help"}
                  placeholder={this.props.Placeholder}
                  defaultValue={this.props.Value}
                  disabled={this.props.Disabled}
                  onChange={this.props.onChange}
                  value={this.props.value}
                  required={this.props.Required}
                  maxLength={this.props.maxLength}
                />
              );
            case "alpha":
              return (
                <>
                  <input
                    type={this.props.Type}
                    className={
                      "form-control" +
                      (this.props.className != null
                        ? " " + this.props.className
                        : "")
                    }
                    onBlur={this.props.handleBlur}
                    id={this.props.Id}
                    name={this.props.Id}
                    aria-describedby={this.props.Id + "Help"}
                    placeholder={this.props.Placeholder}
                    defaultValue={this.props.Value}
                    disabled={this.props.Disabled}
                    onChange={this.onChangeAlpha}
                    pattern="[a-zA-Z\s]{1,}"
                    value={this.props.value}
                    required={this.props.Required}
                    maxLength={this.props.maxLength}
                  />
                  <ValidationErrors {...{ touched, message }} />
                </>
              );
            case "decimal":
              return (
                <input
                  type="number"
                  className={
                    "form-control" +
                    (this.props.className != null
                      ? " " + this.props.className
                      : "")
                  }
                  id={this.props.Id}
                  name={this.props.Id}
                  aria-describedby={this.props.Id + "Help"}
                  placeholder={this.props.Placeholder}
                  defaultValue={this.props.Value}
                  disabled={this.props.Disabled}
                  onChange={this.props.onChange}
                  value={this.props.value}
                  required={this.props.Required}
                  step="any"
                />
              );
            case "passwordEye":
              return (
                <PasswordEye
                  type={this.props.Type}
                  className={
                    "form-control" +
                    (this.props.className != null
                      ? " " + this.props.className
                      : "")
                  }
                  id={this.props.Id}
                  name={this.props.Name}
                  aria-describedby={this.props.Id + "Help"}
                  placeholder={this.props.Placeholder}
                  defaultValue={this.props.Value}
                  disabled={this.props.Disabled}
                  onChange={this.props.onChange}
                />
              );
            case "textarea":
              return (
                <textarea
                  type={this.props.Type}
                  className={
                    "form-control " +
                    (this.props.className != null
                      ? " " + this.props.className
                      : "")
                  }
                  id={this.props.Id}
                  name={this.props.Name}
                  aria-describedby={this.props.Id + "Help"}
                  placeholder={this.props.Placeholder}
                  defaultValue={this.props.Value}
                  disabled={this.props.Disabled}
                  onChange={this.props.onChange}
                />
              );
            case "select":
              return (
                <select
                  className={
                    "form-control" +
                    (this.props.className != null
                      ? " " + this.props.className
                      : "")
                  }
                  id={this.props.Id}
                  name={this.props.Name}
                  aria-describedby={this.props.Id + "Help"}
                  placeholder={this.props.Placeholder}
                  defaultValue={this.props.Value}
                  disabled={this.props.Disabled}
                  onChange={this.props.onChange}
                  value={this.props.value}
                >
                  {this.props.children}
                </select>
              );
            case "date":
              const { value, maxDate, minDate } = this.props;
              const validation = (currentDate) => {
                if (currentDate && maxDate && minDate) {
                  return (
                    currentDate.isBefore(moment(maxDate)) &&
                    currentDate.isAfter(moment(minDate))
                  );
                }
                if (currentDate && maxDate)
                  return currentDate.isBefore(moment(maxDate));
                if (currentDate && minDate)
                  return currentDate.isAfter(moment(minDate));
                return true;
              };

              return (
                <>
                  <Datetime
                    {...{ value }}
                    renderInput={this.renderDateTimeInput}
                    onChange={this.props.onChange}
                    onOpen={this.props.onOpen}
                    dateFormat={"DD/MM/YYYY"}
                    timeFormat={false}
                    closeOnSelect={true}
                    input={true}
                    disabled={this.props.Disabled}
                    inputProps={{
                      placeholder: "DD/MM/YYYY",
                      id: this.props.Id,
                      disabled: this.props.Disabled,
                    }}
                    locale={_.MomentLang}
                    onClose={this.validateDateInput}
                    isValidDate={validation}
                  />
                  <ValidationErrors {...{ touched, message }} />
                </>
              );
            case "RangeSlider":
              return (
                <div className="d-flex flex-row range-slider-wrapper">
                  <span>{this.props.leftLabel}</span>
                  <ReactSlider
                    className="horizontal-slider"
                    thumbClassName="example-thumb"
                    trackClassName="example-track"
                    disabled={this.props.Disabled}
                    {...rest}
                    ariaLabel={["Lower thumb", "Upper thumb"]}
                    ariaValuetext={(state) => `Thumb value ${state.valueNow}`}
                    renderThumb={(props, state) => (
                      <div {...props}>{state.valueNow}</div>
                    )}
                    pearling
                    minDistance={
                      this.props.minDistance ? this.props.minDistance : 1
                    }
                  />
                  <span>{this.props.rightLabel}</span>
                </div>
              );
            case "boolean":
              const checked =
                this.props.value === "1" ||
                this.props.value === "true" ||
                this.props.value === "True";

              return (
                <>
                  <ToggleSwitch
                    id={this.props.Id}
                    onChange={(event) => {
                      event.target.value = !!event.target.checked ? 1 : 0;

                      this.props.onChange(event);
                    }}
                    Small={true}
                    currentValue={checked}
                    disabled={this.props.Disabled}
                  />
                </>
              );
            default:
              return null;
          }
        })()}
        {this.props.HelpText && (
          <small
            id={this.props.Id + "Help"}
            className={
              "form-text text-muted " +
              (this.props.helpClassName != null
                ? " " + this.props.helpClassName
                : "")
            }
          >
            {this.props.HelpText}
          </small>
        )}
      </div>
    );
  }
}
export const mapStateToProps = ({ _ }) => ({ _ });
export default connect(mapStateToProps)(OmniFormGroup);
